import React from 'react';

const KG = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_122"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_122)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#EB0624"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.206 9.485C10.303 9.495 10.401 9.5 10.5 9.5C10.6 9.5 10.697 9.495 10.794 9.485L10.5 8.75L10.206 9.485ZM8.85 8.94C8.327 8.526 8 7.922 8 7.25C8 6.457 8.456 5.76 9.144 5.36L10 7.5L8.85 8.94ZM11.856 5.36C12.544 5.76 13 6.457 13 7.25C13 7.923 12.672 8.527 12.15 8.94L11 7.5L11.856 5.36ZM11.756 5.304C11.386 5.11 10.958 5 10.5 5C10.042 5 9.613 5.11 9.244 5.304L10.5 6.874L11.756 5.304Z"
        fill="#FFF100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 12C12.985 12 15 9.985 15 7.5C15 5.015 12.985 3 10.5 3C8.015 3 6 5.015 6 7.5C6 9.985 8.015 12 10.5 12ZM10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11Z"
        fill="#FFF100"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default KG;
